import { CashierPath } from '@ps/web-pam-types';
import React from 'react';
import QRCode from 'react-qr-code';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { encodeQuery } from '@swf/core/utils';

import PayconiqMark from '../../../../../../../assets/logos/payconiq_mark.svg';
import { CardType } from '../../../../../../../types/cardType';
// TODO refactor to use composition or shared.scss
import { markwrapper, qrbackground, qrcode, qrwrapper } from '../PayconiqRedirect.scss';

interface Props {
  qrCodeData?: string;
  payconiqColor: string;
}

const QrComponent = ({ qrCodeData, payconiqColor }: Props) => {
  const origin = useSelector(select.location.getOrigin);
  const baseURL = useSelector(select.location.getBaseURL);

  if (qrCodeData) {
    const context = encodeQuery({
      appSchemaUrl: qrCodeData,
      cardType: CardType.Payconiq
    });
    const qrUrl = new URL(`${baseURL}${CashierPath.DepositResult}/?${context}`, origin).toString();
    return (
      <div className={qrwrapper}>
        <div className={qrbackground}>
          <QRCode
            size={180}
            className={qrcode}
            fgColor={payconiqColor}
            value={qrUrl}
            viewBox="0 0 180 180"
          />
          <div className={markwrapper}>
            <PayconiqMark />
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default QrComponent;
